export const BIGBOX_DOUBLE = "bigbox-double-inread";

export const BIGBOX = "bigbox";

export const IN_READ = "in-read";

export const OCELOT = "ocelot";

export const READ = "read";
